import { ReactElement } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Grid, Divider, makeStyles } from '@material-ui/core';
import { AnalysisHeader } from '../../app/AnalysisHeader';
import { NewAnalysisSideMenu } from '../../app/NewAnalysisSideMenu';
import { TbaAnalysisHeader } from '../../app/TbaAnalysisHeader';
import { TbaAnalysisSideMenu } from '../../app/TbaAnalysisSideMenu';
export interface LayoutProps {
  aside?: ReactElement;
  header?: ReactElement;
  main?: ReactElement;
}

const useStyles = makeStyles({
  root: {
    height: '100%'
  },
  container: {
    flexGrow: 1,
    overflow: 'auto',
    position: 'relative'
  },
  header: {
    flexBasis: 0
  }
});

export const Layout = ({ aside, header, main }: LayoutProps) => {
  const matchPba = useRouteMatch('/analysis/:studyId/pba-dashboard/:pbaId');
  const matchTba = useRouteMatch('/analysis/:studyId/tba-dashboard/:tbaId');
  const classes = useStyles();

  return (
    <Grid container className={classes.root} direction="column" wrap="nowrap" spacing={0}>
      <Grid item xs={12} component="header" className={classes.header}>
        {matchPba ? <AnalysisHeader /> : matchTba ? <TbaAnalysisHeader /> : header}
      </Grid>
      <Divider />
      <Grid item container className={classes.container} wrap="nowrap" spacing={0}>
        <Grid item xs={3} lg={2} component="aside">
          {matchPba ? <NewAnalysisSideMenu /> : matchTba ? <TbaAnalysisSideMenu /> : aside}
        </Grid>
        <Divider flexItem orientation="vertical" />
        <Grid item xs component="main" className={classes.container}>
          {main}
        </Grid>
      </Grid>
    </Grid>
  );
};
